// src/features/assistant-connect/constants.ts
//
// What a person needs to connect their own AI assistant to Insight. Each assistant signs in with an
// identity client of its own, so the consent screen names it and it can be switched off on its own.
// None of them has a secret: the person leaves that field blank.

export const ASSISTANT_CONNECT_PATH = '/assistant';

/** The assistant server of each Insight; the page picks one from the API address the build calls. */
export const CONNECTION_ENDPOINTS = {
  test: 'https://dev-mcp-insight.roommatik.com/mcp',
  production: 'https://mcp-insight.roommatik.com/mcp',
} as const;

export type AssistantId = 'claude' | 'chatgpt' | 'copilot' | 'cursor';

export const ASSISTANTS: readonly AssistantId[] = ['claude', 'chatgpt', 'copilot', 'cursor'];

export const ASSISTANT_CLIENT_IDS: Record<AssistantId, string> = {
  claude: 'insight-mcp',
  chatgpt: 'insight-mcp-chatgpt',
  copilot: 'insight-mcp-vscode',
  cursor: 'insight-mcp-cursor',
};

/** Local port the terminal's browser sign-in returns to. */
export const CONNECTION_CALLBACK_PORT = 8766;

/** Name the configuration snippets give the server inside the assistant. */
export const SERVER_NAME = 'insight';

/** The one command that connects Claude Code to the assistant server at `url`. */
export const buildConnectCommand = (url: string): string =>
  `claude mcp add --transport http --scope user ${SERVER_NAME} ${url} --client-id ${ASSISTANT_CLIENT_IDS.claude} --callback-port ${CONNECTION_CALLBACK_PORT}`;

/** `mcp.json` for VS Code: the client ID is asked for on the first sign-in, not written here. */
export const vscodeConfig = (url: string): string =>
  JSON.stringify({ servers: { [SERVER_NAME]: { type: 'http', url } } }, null, 2);

/** `mcp.json` for Cursor: the client ID goes in the `auth` block; no secret. */
export const cursorConfig = (url: string): string =>
  JSON.stringify(
    { mcpServers: { [SERVER_NAME]: { url, auth: { CLIENT_ID: ASSISTANT_CLIENT_IDS.cursor } } } },
    null,
    2
  );
